import React from 'react';
import DietCardContent from './resultCardContent/dietCardContent';
import DietCardContentC from './resultCardContent/dietCardContentC';
import DefaultCardContent from './resultCardContent/defaultCardContent';

import './resultCardItem.scss';

const ResultCardItem = ({ result, assessment, inViewport, forwardedRef }) => {
    const { displayType, template } = assessment.resultsConfig;

    let component;
    switch (displayType) {
        case 'diet':
            switch (template) {
                case 'C':
                    component = (
                        <DietCardContentC
                            result={result}
                            inViewport={inViewport}
                            forwardedRef={forwardedRef}
                        />
                    );
                    break;
                default:
                    component = (
                        <DietCardContent
                            result={result}
                            inViewport={inViewport}
                            forwardedRef={forwardedRef}
                        />
                    );
            }
            break;
        default:
            return (
                <DefaultCardContent
                    result={result}
                    assessment={assessment}
                    inViewport={inViewport}
                    forwardedRef={forwardedRef}
                />
            );
    }

    return <>{component}</>;
};

export default ResultCardItem;
